<template>
  <div class="Applybox" >
    <div class="CentBox">
    <div class="title">
        <span >申请试用</span>
        <i class="el-icon-close" @click.stop="canCleApply()"></i>
    </div>
      <el-form ref="form" :model="form" label-width="100px">
        <el-form-item label="联系人">
          <el-input v-model="form.UserName"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="form.other"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" style="width:calc(100% - 30px);" v-model="form.Info" resize='none'></el-input>
        </el-form-item>
        <el-form-item label="温馨提示" class="Tips">
           <p> 1：收到您的请求后，我们会有专人稍后和您取得联系。</p>
           <p>  2：您也可以直接拨打 400-026-9118 咨询或提交。</p>
            <p> 3：我们的工作时间为周一至周五8:30-17:30。</p>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click.stop="onSubmit" style="background:rgba(65, 96, 206, 0.9);color:#fff">立即申请</el-button>
          <el-button @click.stop="canCleApply()">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import {addMsg} from '@/requestPub/api';
export default {
  data() {
    return {
      formLabelWidth: '80px',
      loading: false,
      form: {
        UserName: "",
        other:'',
        Info: "",
      },
    };
  },
  methods: {
      canCleApply(){
          this.$emit('CanCle',false)
      },
    onSubmit() {
      var parames = this.form;
      if(!parames['UserName'] || !parames['other'] || !parames['Info']){
          return this.$message({message:'请先完善信息',type:'warning'});
      }
      parames['ColumnID'] = 14;
      addMsg(parames).then((e)=>{
          this.$message({message:'提交成功',type:'success'});
          this.canCleApply()
          this.form={
            UserName: "",
            other:'',
            Info: "",
          }
      })
    },
  },
};
</script>
<style lang="scss" scoped>
.el-input,.el-textarea__inner{
    width: 80%;
}
.el-timeline {
  padding: 0;
}
.el-textarea__inner{
    min-height: 200px!important;
}
.bannerBox {
  height: 400px;
  .el-carousel__container {
    height: 100%;
  }
  .el-carousel__indicators--outside {
    position: absolute;
    bottom: 100px;
  }
  .el-carousel__item {
    img,
    .el-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
.Tips{
    
    p{
        font-size: 12px;
        line-height: initial;
        margin: 0;
    }
      
}
.Applybox{
   background: rgba(0,0,0,.6);
    position: fixed;
    z-index: 115;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0%;
    display: inline-flex;
    align-items: center;
}
// ConetBox
.CentBox {
    width: 60%;
    height:400px;
    margin: 0 auto;
    text-align: left;
    padding: 20px 0;
    background: #fff;
    .title{
        height:50px;
        width: 100%;
        vertical-align: middle;
        font-size: 18px;
        font-weight: bold;
        color: #606266;
        line-height: 40px;
        padding: 0 12px 0 0;
        box-sizing: border-box;
        display: inline-flex;
        justify-content: space-between;
        span{
            width: 100px;
            display: inline-block;
            text-align: right;
        }
        i{
            &:hover{
                cursor: pointer;
                color:#4160ce;
            }
        }
    }
}
</style>